
/* injects from baggage-loader */

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {addIntegration, fetchIntegrations} from 'redux/modules/integrations/actions'
import PromptContainer from 'components/PromptContainer'
import FormInput from 'components/FormInput'
import {Field, reduxForm, SubmissionError} from 'redux-form'
import ButtonsGroup from 'components/ButtonsGroup'
import FormError from 'components/FormError'

export class IntegrationsNewCriteo extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    error: PropTypes.string
  }

  render() {
    const {
      handleSubmit,
      invalid,
      submitting,
      closeModal,
      error
    } = this.props

    return (
      <PromptContainer title='Connect Criteo Account'>
        <form onSubmit={handleSubmit}>
          {/* eslint-disable max-len */}
          <p>To connect Criteo you need to generate an API for your account.</p>
          <p>Please follow instructions from Criteo Support Center: <a target='_blank' href='https://support.criteo.com/hc/en-us/articles/210162145-How-can-I-manually-generate-an-API-for-my-account-'>How can I manually generate an API for my account?</a></p>
          {/* eslint-enable max-len */}
          <Field
            name='username'
            disabled={submitting}
            label='Username (email)'
            component={FormInput}
          />
          <Field
            type='password'
            name='password'
            disabled={submitting}
            label='Password'
            component={FormInput}
          />
          <FormError text={error} />
          <ButtonsGroup align='right'>
            <button className='button is-transparent' type='button' onClick={closeModal}>Cancel</button>
            <button type='submit' className='button' disabled={submitting || invalid}>Connect Criteo</button>
          </ButtonsGroup>
        </form>
      </PromptContainer>
    )
  }
}

const mapStateToProps = (state, {currentSite}) => {
  return {merchantSite: currentSite}
}

export default connect(mapStateToProps, {
  closeModal
})(reduxForm({
  form: 'IntegrationsNewCriteo',
  touchOnChange: true,
  validate: ({username, password}) => {
    const errors = {}

    if (!username) {
      errors.username = 'You need to specify Criteo username'
    }

    if (!password) {
      errors.password = 'You need to specify Criteo password'
    }

    return errors
  },
  onSubmit: ({username, password}, dispatch, {currentSite}) => new Promise((resolve, reject) => {
    const {id: merchantSiteId, currency} = currentSite
    dispatch(addIntegration('criteo', {username, password, currency, merchantSiteId}))
      .success(() => {
        dispatch(closeModal())
        dispatch(fetchIntegrations())
        resolve()
      })
      .fail(err => {
        reject(new SubmissionError({_error: err.message}))
      })
  })
})(IntegrationsNewCriteo))



// WEBPACK FOOTER //
// ./client/modals/IntegrationsNewCriteo/index.js